module.exports = __webpack_public_path__ + "img/section-3-content_3_about.8fb539d4.png";